export default "__VITE_ASSET__ChsB4ofn__"